import { ProductStatus } from 'gql/types';
import { TFunction } from 'i18next';
import { ReportFilterOptions } from 'modules/reports/hooks/useReportFilterOptions';
import {
  PartialProductReport,
  ReportFilterConfig,
} from 'modules/reports/types';

type ProductReportContext = {
  categoriesMap?: Record<number, string>;
};

export const getProductReportFilters = (
  t: TFunction,
  { regionNames }: ReportFilterOptions,
  categoryNames: string[] = []
): ReportFilterConfig<PartialProductReport>[] => [
  {
    key: 'createdAt',
    label: t('createdAt'),
    type: 'dateRange',
    getValue: (item) => item.createdAt,
  },
  {
    key: 'expirationDate',
    label: t('expirationDate'),
    type: 'dateRange',
    getValue: (item) => item.expirationDate,
  },
  {
    key: 'status',
    label: t('status'),
    type: 'multiselect',
    getValue: (item) => item.status,
    options: Object.values(ProductStatus),
  },
  {
    key: 'productRegion',
    label: t('productRegion'),
    type: 'multiselect',
    getValue: (item) => item.regionPreference?.name,
    options: regionNames,
  },
  {
    key: 'productCategoryName',
    label: t('productCategoryName'),
    type: 'multiselect',
    getValue: (item, context: ProductReportContext) =>
      context?.categoriesMap?.[item.woocommerceCategoryId],
    options: categoryNames,
  },
];
